import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
const Tab3 = ({
  TaxCategory,
  TaxID,
  TaxWithholdingCategory,
  GSTIN_UIN,
  PAN,
  GSTCategory,
}) => {
  return (
        <div>
      <div className="px-2 py-3" style={{ background: 'white' }}>
        <div style={{ display: 'flex' }} >
          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Purchasing Details</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                 <div style={{ flex: 1 }}>
                  <Input
              id="TaxID"
              label="Tax ID"
              style={{ height: "30px" }}
              value={TaxID.value}
              onChange={(e) => TaxID.setValue(e.target.value)}
            />

                </div>
                <div style={{ flex: 1 }}>
                   <SelectSearch
              list={TaxCategory.TaxCategory_list}
              style={{
                height: "30px",
                border: TaxCategory.Error ? "1px solid red" : "",
              }}
              label="Tax Category"
              getOptionLabel={(item) => item.name} // 👈 Required
              getOptionValue={(item) => item.name} // 👈 Required
              value={TaxCategory.value}
              onChange={(val) => TaxCategory.setValue(val)}
            />


                </div>
                <div style={{ flex: 1 }}>
                   <SelectSearch
              list={TaxWithholdingCategory.TaxWithholdingCategory_list}
              style={{
                height: "30px",
                border: TaxWithholdingCategory.Error ? "1px solid red" : "",
              }}
              label="Tax With holding Category"
              getOptionLabel={(item) => item.name} // 👈 Required
              getOptionValue={(item) => item.name} // 👈 Required
              value={TaxWithholdingCategory.value}
              onChange={(val) =>
                TaxWithholdingCategory.setValue(val)
              }
            />
                </div>
              </div>


            </div>
          </div>

          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Tax Details</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>

               <div style={{ flex: 1 }}>
                  <Input
              id="GSTIN_UIN"
              label="GSTIN / UIN"
              style={{ height: "30px" }}
              value={GSTIN_UIN.value}
              onChange={(e) => GSTIN_UIN.setValue(e.target.value)}
            />
                </div>
                <div style={{ flex: 1 }}>
                 <Input
              id="PAN"
              label="PAN"
              style={{ height: "30px" }}
              value={PAN.value}
              onChange={(e) => PAN.setValue(e.target.value)}
            />



                </div>
                <div style={{ flex: 1 }}>
                 <SelectSearch
              list={[
                { name: "Registered Regular" },
                { name: "Registered Composition" },
                { name: "Unregistered" },
                { name: "SEZ" },
                { name: "Overseas" },
                { name: "Deemed Export" },
                { name: "UIN Holders" },
                { name: "Tax Deductor" },
                { name: "Tax Collector" },
                { name: "Input Service Distributor" },
              ]}
              style={{
                height: "30px",
                border: GSTCategory?.Error ? "1px solid red" : "",
              }}
              label="GST Category"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={GSTCategory?.value || ""}
              onChange={(value) => GSTCategory?.setValue?.(value)}
            />
                </div>

              </div>




            </div>
          </div>
        </div>
        
      </div>

    </div>
  );
};

export default Tab3;
